<template>
  <div class="mt-7 login-section">
    <div class="tf-container">
      <div class="tf-form" v-if="!confirmarEmailCelular">
        <div v-if="idEmitenteML" style="text-align: center; margin-bottom: 30px;">
          <img :src="'https://backend.micrologos.com.br/auth/logomarcaCliente/' + idEmitenteML" class="logo" style="max-width: 300px; width: auto;" />
        </div>
        <div style="text-align: center; margin-bottom: 30px;">
          <img src="/images/paylogos_logo2.png" class="logo" style="max-width: 160px; vertical-align: middle;" />
          <img src="https://paylogos.com.br/images/zoop.svg" class="logo" style="max-width: 75px; vertical-align: middle;" />
        </div>
        <h1>
          Anuidade 2026
        </h1>
        <InputCPF 
          placeholder="CPF" 
          v-model="cpf" 
          :disabled="isLoading" 
          @keyup="verificaBuscaCPF" 
          :required="true"
        />
      </div>
      <div class="tf-form tf-form-verify" v-if="confirmarEmailCelular">
        <h1 class="text-center">
          Confirmar sua Conta
        </h1>
        <p class="mb-7 fw-3 text-center">
          Um código de confirmação foi enviado para {{ opcaoEnviada.alvo }}. Digite o código a baixo:
        </p>
        <div class="d-flex group-input-verify">
          <input 
            ref="codigoConfirmacao1" 
            v-model="codigoConfirmacao1" 
            type="number" 
            maxlength="1" 
            pattern="[0-9]" 
            class="input-verify" 
            @keyup="focusInput($event, 2)" 
            @paste="pasteCodigoConfirmacao"
          />
          <input 
            ref="codigoConfirmacao2" 
            v-model="codigoConfirmacao2" 
            type="number" 
            maxlength="1" 
            pattern="[0-9]" 
            class="input-verify" 
            @keyup="focusInput($event, 3)"
          />
          <input 
            ref="codigoConfirmacao3" 
            v-model="codigoConfirmacao3" 
            type="number" 
            maxlength="1" 
            pattern="[0-9]" 
            class="input-verify" 
            @keyup="focusInput($event, 4)"
          />
          <input 
            ref="codigoConfirmacao4" 
            v-model="codigoConfirmacao4" 
            type="number" 
            maxlength="1" 
            pattern="[0-9]" 
            class="input-verify" 
            @keyup="focusInput($event, 5)"
          />
          <input 
            ref="codigoConfirmacao5" 
            v-model="codigoConfirmacao5" 
            type="number" 
            maxlength="1" 
            pattern="[0-9]" 
            class="input-verify" 
            @keyup="focusInput($event, 6)"
          />
          <input 
            ref="codigoConfirmacao6" 
            v-model="codigoConfirmacao6" 
            type="number" 
            maxlength="1" 
            pattern="[0-9]" 
            class="input-verify" 
            @keyup="focusInput($event, 7)"
          />
        </div>
        <div class="text-send-code">
          <p class="fw_4">
            Um código de 6 dígitos foi enviado via SMS e E-mail.
          </p>
          <p v-if="contadorReenviar > 0" class="primary_color fw_7">
            Reenviar em &nbsp;<span class="js-countdown">{{ contadorReenviar }}</span>&nbsp;segundos
          </p>
          <p v-if="contadorReenviar == 0" class="primary_color fw_7">
            <a 
              href="javascript:;" 
              class="auth-link-rg" 
              @click="reenviarCodigoConfirmacao"
            >
              Reenviar um novo código
            </a>
          </p>
        </div>
        <div class="bottom-navigation-bar bottom-btn-fixed">
          <ButtonPadrao 
            label="Continuar" 
            :isLoading="isLoading" 
            @click="verificarCodigoConfirmacaoLocal"
          />
        </div>
      </div>
    </div>
    <AlertBox ref="alertBox">
    </AlertBox>
  </div>
  <PanelTopDown 
    ref="panelTopDown" 
    title="Clique em uma das opções abaixo para receber o código de confirmação" 
    @selecionado="enviarConfirmacao"
  />
  <WhatsAppButton></WhatsAppButton>
</template>

<script>
import Swal from "sweetalert2";
import JwtService from "@/store/jwt.service";
import { mapActions, mapGetters } from "vuex";

import InputCPF from "@/components/inputs/InputCPF.vue";
import PanelTopDown from "@/components/PanelTopDown.vue";
import WhatsAppButton from "@/components/WhatsAppButton.vue";

import AlertBox from "@/components/AlertBox.vue";
import ButtonPadrao from "@/components/buttons/ButtonPadrao.vue";

export default {
  name: "LoginCpfView",
  components: {
    InputCPF,
    AlertBox,
    ButtonPadrao,
    PanelTopDown,
    WhatsAppButton
  },
  data() {
    return {
      isLoading: false, 
      idEmitenteML: "",
      cpf: "",
      opcaoEnviada: {}, 
      contadorReenviar: 0,
      timerContadorReenviar: null,
      confirmarEmailCelular: false,
      codigoConfirmacao: "",
      codigoConfirmacao1: "",
      codigoConfirmacao2: "", 
      codigoConfirmacao3: "",
      codigoConfirmacao4: "",
      codigoConfirmacao5: "",
      codigoConfirmacao6: "" 
    };
  },
  async mounted() {
    this.iniciarContadorReenviar();

    if(JwtService.getToken()) {
      let validacao = await this.getValidateToken();

      if(validacao.resultado) {
        this.$router.push({
          name: "home"
        });
      }
    } else if(!this.$route.params.idEmitenteML) {
      this.$router.push({
        name: "login"
      });
    } else {
      this.idEmitenteML = this.$route.params.idEmitenteML;
    }
  },
  computed: {
    ...mapGetters([
      "usuarioRealizarLogin", 
      "senhaRealizarLogin"
    ])
  },
  methods: {
    ...mapActions([
      "realizarLogin", 
      "atualizarUsuarioRealizarLogin", 
      "atualizarSenhaRealizarLogin",
      "getUserRegistered",
      "enviarCodigoLoginCpfPaylogos",
      "verificarCodigoLoginCpfPaylogos", 
      "getValidateToken"
    ]), 
    iniciarContadorReenviar() {
      this.timerContadorReenviar = setInterval(() => {
        if(this.contadorReenviar > 0) {
          this.contadorReenviar--;
        }
      }, 1000);
    }, 
    async verificaBuscaCPF() {
      await this.$nextTick();

      if(this.cpf.length == 14) {
        this.buscarCadastro();
      }
    },
    async buscarCadastro() {
      if(this.cpf) {
        this.isLoading = true;

        let resultado = await this.getUserRegistered({
          CPF: this.cpf, 
          ID_EMITENTE_ML: this.idEmitenteML
        });

        this.isLoading = false;

        if(resultado.registrado) {
          let opcoes = [];

          if(resultado.opcoesEnvio.EMAIL) {
            opcoes.push({
              value: "EMAIL", 
              alvo: resultado.opcoesEnvio.EMAIL, 
              title: "Via e-mail", 
              description: "Receber o código de confirmação pelo e-mail: " + resultado.opcoesEnvio.EMAIL
            });
          }

          if(resultado.opcoesEnvio.CELULAR) {
            opcoes.push({
              value: "CELULAR", 
              alvo: resultado.opcoesEnvio.CELULAR, 
              title: "Via SMS", 
              description: "Receber o código de confirmação via SMS no número: " + resultado.opcoesEnvio.CELULAR
            });
          }

          this.$refs.panelTopDown.exibirOpcoes(opcoes);
        } else if(resultado.registradoEmitente) {
          this.$router.push({
            name: "registerEmitenteML", 
            params: {
              idEmitenteML: this.idEmitenteML
            }
          });
        } else {
          this.$router.push({
            name: "associeseEmitenteML", 
            params: {
              idEmitenteML: this.idEmitenteML
            }
          });
        }
      } else {
        this.$refs.alertBox.show(
          "error", 
          "Erro", 
          "", 
          "", 
          "CPF não informado."
        );
      }
    },
    async enviarConfirmacao(opcao) {
      this.confirmarEmailCelular = true;
      this.contadorReenviar = 60;
      this.opcaoEnviada = opcao;

      this.$refs.panelTopDown.close();

      this.isLoading = true;

      this.enviarCodigoLoginCpfPaylogos({
        ID_EMITENTE_ML: this.idEmitenteML, 
        TIPO: opcao.value, 
        CPF: this.cpf
      });

      this.isLoading = false;

      await this.$nextTick();

      this.$refs.codigoConfirmacao1.focus();
    },
    focusInput(event, codigo) {
      if(!isNaN(event.key)) {
        if(codigo == 1) {
          this.$refs.codigoConfirmacao1.focus();
        } else if(codigo == 2) {
          this.$refs.codigoConfirmacao2.focus();
        } else if(codigo == 3) {
          this.$refs.codigoConfirmacao3.focus();
        } else if(codigo == 4) {
          this.$refs.codigoConfirmacao4.focus();
        } else if(codigo == 5) {
          this.$refs.codigoConfirmacao5.focus();
        } else if(codigo == 6) {
          this.$refs.codigoConfirmacao6.focus();
        } else if(codigo == 7) {
          this.verificarCodigoConfirmacaoLocal();
        }
      } else if(event.key == "Backspace") {
        if(codigo == 3) {
          this.$refs.codigoConfirmacao1.focus();
        } else if(codigo == 4) {
          this.$refs.codigoConfirmacao2.focus();
        } else if(codigo == 5) {
          this.$refs.codigoConfirmacao3.focus();
        } else if(codigo == 6) {
          this.$refs.codigoConfirmacao4.focus();
        } else if(codigo == 7) {
          this.$refs.codigoConfirmacao5.focus();
        }
      }
    }, 
    async pasteCodigoConfirmacao(event) {
      if((event) && (event.clipboardData) && (event.clipboardData.getData) && (event.clipboardData.getData("text/plain"))) {
        let codigo = event.clipboardData.getData("text/plain");
        codigo = codigo.replace(/[^0-9]/g, "");

        if(codigo.length == 6) {
          let codigos = codigo.split("");
          this.codigoConfirmacao1 = codigos[0];
          this.codigoConfirmacao2 = codigos[1];
          this.codigoConfirmacao3 = codigos[2];
          this.codigoConfirmacao4 = codigos[3];
          this.codigoConfirmacao5 = codigos[4];
          this.codigoConfirmacao6 = codigos[5];

          await this.$nextTick();
          this.verificarCodigoConfirmacaoLocal();
        }
      }
    },
    async verificarCodigoConfirmacaoLocal() {
      this.codigoConfirmacao = this.codigoConfirmacao1.toString() + 
        this.codigoConfirmacao2.toString() + 
        this.codigoConfirmacao3.toString() + 
        this.codigoConfirmacao4.toString() + 
        this.codigoConfirmacao5.toString() + 
        this.codigoConfirmacao6.toString();

      if(this.codigoConfirmacao.length == 6) {
        this.isLoading = true;

        let resultado = await this.verificarCodigoLoginCpfPaylogos({
          ID_EMITENTE_ML: this.idEmitenteML, 
          CPF: this.cpf, 
          CODIGO_LOGIN: this.codigoConfirmacao, 
          TIPO: this.opcaoEnviada.value
        });

        this.isLoading = false;
        
        if(resultado.resultado) {
          await this.$nextTick();
          this.$router.push({
            name: "home"
          });
        } else {
          Swal.fire({
            icon: "error", 
            title: "Erro", 
            text: "Código de login inválido.", 
            timer: 3000, 
            timerProgressBar: true
          });
        }
      }
    }
  }
}
</script>

<style scoped>
  .logo {
    width: 100%;
    max-width: 200px;
    margin-bottom: 30px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield; /* Standard property for broader compatibility */
  }
</style>